import React from 'react';
import cn from 'classname';
import NoteForm from '../form/note-form';

const Row = (props) => {
	const {
		row, intervals, can, expandedAffiliateIds, fetchExtendedData, loadingAffiliateId,
		setNoteParams, noteData, toggleNotePopup, periodSwitch, notePopupData, isHiddenProfit
	} = props;
	const dates = intervals || [];
	const datesNumber = dates ? dates.length : null;
	const isAffiliateRow = !!row.affiliate;

	return (
		<tr className={cn({
			'top-affiliate-total-row': !isAffiliateRow, 'top-affiliate-individual-row': !!isAffiliateRow,
			'no-copy-col': !props.can('canCopyTotalRow') && !isAffiliateRow
		})}>
			{
				isAffiliateRow &&
				<td className="fixed-col bald-font cursor-default first-affiliate-col">
					<p>{row.affiliate_id}</p>
					<p>{row.affiliate}</p>
					<span
						className={cn({
							'hover-pointer': true,
							'dropdown-icon': true,
							'expand__icon': true,
							'rotating': loadingAffiliateId === row.affiliate_id,
							'expand__icon--opened': expandedAffiliateIds.includes(row.affiliate_id)
						})}
						onClick={fetchExtendedData.bind(null, row.affiliate_id)}
					/>
				</td>
			}
			{
				isAffiliateRow && <td className="text-center">
					{row.manager && row.manager
						.replace('{', '')
						.replace('}', '')
						.split(',')
						.map((item, key) => <p key={key}> {item} </p>)
					}
					<span className="opacity-0">{'š'}</span>
				</td>
			}
			{
				isAffiliateRow &&
					<td
						className={cn({ 'no-copy-col': !!isAffiliateRow, 'text-center': true, 'balance-col': true })}
					>
						{row.balances && row.balances.usd || 0} $
					</td>
			}
			{
				!isAffiliateRow && <td className="fixed-col bald-font first-affiliate-col" colSpan={1}>TOTAL</td>
			}
			{
				!isAffiliateRow && <td colSpan={2}/>
			}
			<td
				className={cn({
					'top-affiliates-table-cell_description': true,
					'no-copy-col': !!isAffiliateRow,
					'forecast-cell': true
				})}>
				<p className='flex-center'>
					<span className="width-50-p padding-0-5 text-right">
						{`${Math.round((row[`total_all_statuses`] || 0) / datesNumber)} `}
					</span>|
					<span className=" width-50-p padding-0-5 text-left light-green-text">
						{` ${Math.round((row[`total_approved`] || 0) / datesNumber)}`}
					</span>
				</p>
				<p className='flex-center'>
					<span className="width-50-p padding-0-5 text-right">
						{`${row[`total_all_statuses_approve_percent`] || 0} `}%
					</span>|
					<span className=" width-50-p padding-0-5 text-left light-green-text">
						{` ${row[`total_valid_approve_percent`] || 0}`}%
					</span>
				</p>
				{can('viewAll')
					&& <p className='flex-center'>Profit {Math.round((row[`total_profit_usd`] || 0) / datesNumber)}$</p>
				}
			</td>
			{
				dates.map((item, key, arr) =>
					<ConversionsDateCell
						{...props}
						arr={arr} item={item} row={row} can={can} key={key} index={key}
						setNoteParams={setNoteParams} noteData={noteData} toggleNotePopup={toggleNotePopup}
						periodSwitch={periodSwitch} fetchExtendedData={fetchExtendedData} notePopupData={notePopupData}
					/>
				)
			}
			<td className={cn({'top-affiliates-table-cell_description': true, 'no-copy-col': !!isAffiliateRow })}>
				<p className='flex-center'>
					<span className="width-50-p padding-0-5 text-right">
						{`${row[`total_all_statuses`] || 0} `}
					</span>|
					<span className=" width-50-p padding-0-5 text-left light-green-text">
						{` ${row[`total_approved`] || 0}`}
					</span>
				</p>
				<p className='flex-center'>
					<span className="width-50-p padding-0-5 text-right">
						{`${row[`total_all_statuses_approve_percent`] || 0} `}%
					</span>|
					<span className=" width-50-p padding-0-5 text-left light-green-text">
						{` ${row[`total_valid_approve_percent`] || 0}`}%
					</span>
				</p>
				{
					can('viewAll') && !isHiddenProfit &&
						<p className='flex-center'>Profit {Math.round(row[`total_profit_usd`]) || 0}$</p>
				}
			</td>
		</tr>
	);
};

const ConversionsDateCell = props => {
	const {
		item, arr, can, row, index, noteData, toggleNotePopup, periodSwitch, notePopupData, isHiddenProfit
	} = props;

	const isAffiliateRow = !!row.affiliate;

	const isActiveCommentedCell = !!notePopupData
		&& notePopupData.date === item
		&& notePopupData.affiliate_id === row['affiliate_id']
		&& !notePopupData.country_code
		&& !notePopupData.offer_id;

	const hasAffiliateId = !!row['affiliate_id'];
	const notes = noteData && noteData
		.filter(() => hasAffiliateId)
		.filter(nd => nd.affiliate_id === row['affiliate_id'])
		.filter(nd => nd.date === item)
		.filter(nd => !nd.country_code)
		.filter(nd => !nd.offer_id);

	const isMoreThenBefore = !!arr[index + 1] &&
		Number(row[`${item}_all_statuses`]) > Number(row[`${arr[index + 1]}_all_statuses`]);

	const isLessThenBefore = !!arr[index + 1] &&
		Number(row[`${item}_all_statuses`]) < Number(row[`${arr[index + 1]}_all_statuses`]);

	return <td
		className={cn({
			'top-affiliates-table-cell_description': true,
			'no-copy-col': !!isAffiliateRow,
			'active-commented-cell': isActiveCommentedCell
		})}
	>
		{
			isActiveCommentedCell &&
			<NoteForm {...props} form='topAffiliateNoteForm' />
		}
		<p className='flex-center'>
			<span className="width-50-p padding-0-5 text-right">
				{`${row[`${item}_all_statuses`] || 0} `}
			</span>|
			<span className=" width-50-p padding-0-5 text-left light-green-text">
				{` ${row[`${item}_approved`] || 0}`}
				<span className={cn({ 'less': isLessThenBefore, 'more': isMoreThenBefore })}></span>
			</span>
			{
				hasAffiliateId && !periodSwitch &&
				<span
					className={cn({'add-comment': true, 'has-comment-inside': !!notes && !!notes.length && !periodSwitch })}
					onClick={toggleNotePopup.bind(null, { row, item })}
				>
					+
				</span>
			}
		</p>
		<p className='flex-center'>
			<span className="width-50-p padding-0-5 text-right">
				{`${row[`${item}_all_statuses_approve_percent`] || 0} `}%
			</span>|
			<span className=" width-50-p padding-0-5 text-left light-green-text">
				{` ${row[`${item}_valid_approve_percent`] || 0}`}%
			</span>
		</p>
		{
			can('viewAll') && !isHiddenProfit &&
				<p className="text-center">Profit {Math.round(row[`${item}_profit_usd`]) || 0}$</p>
		}
	</td>;
};

export default Row;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/top-affiliates/components/table/row.js